import { createRouter, createWebHashHistory } from 'vue-router'
import http from '@/utils/httpRequest'
import { isURL } from '@/utils/validate'

// 动态导入（Vue CLI 推荐写法）
const _import = (file) =>
  () => import(`@/views/${file}.vue`)

/* =======================
   全局路由（无需 layout）
   ======================= */
const globalRoutes = [
  {
    path: '/404',
    name: '404',
    component: _import('common/404'),
    meta: { title: '404未找到' }
  },
  {
    path: '/login',
    name: 'login',
    component: _import('common/login'),
    meta: { title: '登录' }
  }
]

/* =======================
   主入口路由（layout）
   ======================= */
const mainRoutes = {
  path: '/',
  name: 'main',
  component: _import('main'),
  redirect: { name: 'login' },
  meta: { title: '主入口整体布局' },
  children: [
    {
      path: '/home',
      name: 'home',
      component: _import('common/home'),
      meta: { title: '首页', isTab: true }
    },
    {
      path: '/theme',
      name: 'theme',
      component: _import('common/theme'),
      meta: { title: '主题', isTab: true }
    },
    {
      path: '/home-index',
      name: 'home-index',
      component: _import('modules/home/index'),
      meta: { title: '数据总览', isTab: true }
    }
  ],
  beforeEnter: (to, from, next) => {
    const token = localStorage.getItem('token')
    if (!token) {
      next({ name: 'login' })
    } else {
      next()
    }
  }
}

/* =======================
   创建 Router
   ======================= */
const router = createRouter({
  history: createWebHashHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [...globalRoutes, mainRoutes]
})

/* =======================
   是否已添加动态路由
   ======================= */
let isAddDynamicMenuRoutes = false

/* =======================
   全局前置守卫
   ======================= */
router.beforeEach(async (to, from, next) => {
  // 全局路由 or 已添加动态路由
  if (
    isAddDynamicMenuRoutes ||
    globalRoutes.find(r => r.name === to.name)
  ) {
    return next()
  }

  const { data } = await http.get('/sys/menu/nav')

  if (data && data.code === 0) {
    addDynamicMenuRoutes(data.menuList)
    isAddDynamicMenuRoutes = true

    saveMenuListToStorage(data.menuList)
    sessionStorage.setItem('permissions', JSON.stringify(data.permissions))
    next({ path: to.fullPath, replace: true })
  } else {
    sessionStorage.setItem('menuList', '[]')
    sessionStorage.setItem('permissions', '[]')
    next()
  }
})

/* =======================
   判断路由类型
   ======================= */
// function getCurrentRouteType(route) {
//   let temp = []

//   for (const r of globalRoutes) {
//     if (r.path === route.path) return 'global'
//     if (r.children) temp.push(...r.children)
//   }

//   return temp.length ? getCurrentRouteType(route) : 'main'
// }

/* =======================
   添加动态路由
   ======================= */
function addDynamicMenuRoutes(menuList = [], routes = []) {
  const temp = []

  menuList.forEach(menu => {
    if (menu.list?.length) {
      temp.push(...menu.list)
    }

    // 所有有 menuId 的菜单都创建路由记录
    if (!menu.menuId) return

    const route = {
      path: menu.url ? menu.url.replace(/^\//, '').replace(/\//g, '-') : `m-${menu.menuId}`,
      name: menu.url ? menu.url.replace(/^\//, '').replace(/\//g, '-') : `m-${menu.menuId}`,
      meta: {
        menuId: menu.menuId,
        title: menu.name,
        isDynamic: true,
        isTab: true,
        iframeUrl: ''
      }
    }

    if (menu.url && isURL(menu.url)) {
      route.path = `i-${menu.menuId}`
      route.name = `i-${menu.menuId}`
      route.meta.iframeUrl = menu.url
    } else if (menu.url) {
      route.component = _import(`modules/${menu.url.replace(/^\//, '')}`)
    }

    routes.push(route)
  })

  if (temp.length) {
    addDynamicMenuRoutes(temp, routes)
  } else {
    mainRoutes.children.push(...routes)

    routes.forEach(route => {
      router.addRoute('main', route)
    })

    router.addRoute({ path: '/:pathMatch(.*)*', redirect: '/404' })

    // 存储路由列表
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(routes))
  }
}

// 单独存储完整菜单树（用于侧边栏查找）
export function saveMenuListToStorage(menuList) {
  sessionStorage.setItem('menuList', JSON.stringify(menuList))
}

/* =======================
   重置路由状态（退出登录时调用）
   ======================= */
export function resetRouterState() {
  isAddDynamicMenuRoutes = false
  mainRoutes.children = mainRoutes.children.filter(
    child => !child.meta?.isDynamic
  )
}

export default router